<div class="outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">
    <div class="name-container">
      <span>{{ title }}</span>
      <input class="btn btn-default cst-btn" type="submit" value="Save Changes" (click)="saveChanges()" />
      <input class="btn btn-default cst-btn" type="submit" value="Go Back" (click)="goBack()" />
    </div>
    <div class="details">
      <div class="heading">
        <span class="sub-heading">CAMPAIGN DETAILS</span>

        <hr class="solid-divider" />
      </div>
      <div class="row crud-container">
        <div class="form-group inp-txt">
          <label for="campaignName">Name</label>
          <input
            type="text"
            class="form-control inp"
            id="campaignName"
            placeholder="Name"
            [value]="campaignDetail?.Name"
          />
        </div>

        <div class="form-group inp-txt">
          <label for="campaignDescription">Description</label>
          <input
            type="text"
            class="form-control inp"
            id="campaignDescription"
            placeholder="Description"
            [value]="campaignDetail?.Description"
          />
        </div>

        <div class="form-group inp-txt">
          <label for="crmCampaignID">CRM Campaign ID</label>
          <input
            type="text"
            class="form-control inp"
            id="crmCampaignID"
            placeholder="CRM Campaign ID"
            [value]="campaignDetail?.CrmCampaignID"
          />
        </div>
      </div>

      <div class="row crud-container">
        <div class="form-group inp-txt">
          <label class="search-label" for="channeldropdown">Channel</label>
          <select id="channeldropdown" class="inp" [(ngModel)]="campaignDetail.IVRPrompt.Channel">
            <ng-container *ngFor="let item of channels">
              <option [ngValue]="item.label">{{ item.label }}</option>
            </ng-container>
          </select>
        </div>

        <div class="form-group inp-txt">
          <label class="search-label" for="channelTypedropdown">Channel Type</label>
          <select id="channelTypedropdown" class="inp" [(ngModel)]="campaignDetail.IVRPrompt.Type">
            <ng-container *ngFor="let item of channelTypes">
              <option [ngValue]="item.label">{{ item.label }}</option>
            </ng-container>
          </select>
        </div>
      </div>

      <div class="row crud-container">
        <div class="form-group inp-txt">
          <label for="status">Status</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control inp"
            id="status"
            placeholder="Status"
            [value]="campaignDetail?.Status"
          />
        </div>

        <div class="form-group inp-txt">
          <label for="createdOn">Created On</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control inp"
            id="createdOn"
            placeholder="Created On"
            [value]="campaignDetail?.Created | custdate"
          />
        </div>

        <div class="form-group inp-txt">
          <label for="lastUpdatedOn">Last Updated On</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control inp"
            id="lastUpdatedOn"
            placeholder="Last Updated On"
            [value]="campaignDetail?.LastUpdated | custdate"
          />
        </div>
      </div>

      <div class="row crud-container">
        <div class="form-check mt-1">
          <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked />
          <label class="form-check-label" for="flexCheckChecked"> Log Calls to API </label>
        </div>
      </div>

      <div class="row crud-container" *ngIf="campaignDetail.Status !== 'Pending'">
        <div class="form-group no-padding">
          <button class="btn btn-primary update-btn" (click)="saveChanges()" style="float: left">Resume</button>
          <button class="btn btn-danger update-btn" (click)="saveChanges()" style="float: left">Cancel</button>
        </div>
      </div>
    </div>

    <!------------ Section 2 ---------->
    <div class="details">
      <div class="heading">
        <span class="sub-heading">PHONE CALL CONFIGURATION</span>
        <hr class="solid-divider" />
      </div>

      <div class="row crud-container">
        <div class="form-group inp-txt col">
          <label class="search-label" for="callFrom">Call From</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control inp"
            id="callFrom"
            placeholder="Call From"
            [value]="campaignDetail.CampaignRun.OutboundPhoneNumber"
          />
        </div>

        <div class="col"></div>

        <div class="input-group col inp-txt">
          <label class="search-label" for="callFrom">Make a Test Call</label>
        </div>
      </div>

      <div class="row crud-container mt-1">
        <div class="col-2">
          <label class="form-check-label checkbox-inline">Available On</label>
        </div>
        <div class="col form-group">
          <label *ngFor="let day of weekdays" class="col-md-1 cbl" for="{{ day.label }}">
            <input
              class="form-check-input"
              type="checkbox"
              name="checkboxes"
              id="{{ day.label }}"
              value="{{ day.label }}"
              [checked]="availabeOnDay == day.label"
              disabled
            />
            {{ day.label }}
          </label>
        </div>
      </div>

      <div class="row crud-container mt-1">
        <div class="col-2" style="padding-top: 2rem">
          <label class="form-check-label checkbox-inline">Time Between</label>
        </div>

        <div class="form-group inp-txt w-10">
          <div class="form-group">
            <label for="startTime">Start Time</label>
            <div class="input-group date" id="startTime">
              <input type="time" class="form-control timePicker inp pad-0" [(ngModel)]="campaignRunActiveStartTime" />
            </div>
          </div>
        </div>

        <div class="form-group inp-txt w-10">
          <div class="form-group">
            <label for="endTime">End Time</label>
            <div class="input-group date" id="endTime">
              <input type="time" class="form-control timePicker inp pad-0" [(ngModel)]="campaignRunActiveEndTime" />
            </div>
          </div>
        </div>
      </div>

      <div class="row crud-container mt-1">
        <div class="form-group inp-txt">
          <label class="search-label" for="channelTypedropdown">Time Zone</label>
          <select id="channelTypedropdown" class="inp" [(ngModel)]="campaignRunActiveTimeZone">
            <ng-container *ngFor="let item of timeZones">
              <option [ngValue]="item.label">{{ item.value }}</option>
            </ng-container>
          </select>
        </div>
      </div>
      <div class="row crud-container">
        <div class="form-group inp-txt">
          <label class="search-label" for="attempts">Attempts</label>
          <select id="attempts" class="inp" [(ngModel)]="campaignDetail.CampaignRun.AttemptsPerContact">
            <option [ngValue]="campaignDetail.CampaignRun.AttemptsPerContact">
              {{ campaignDetail.CampaignRun.AttemptsPerContact }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!------------ Section 3 ---------->
    <div class="details">
      <div class="heading">
        <span class="sub-heading">MESSAGE PROMPT SETTINGS</span>
        <hr class="solid-divider" />
      </div>

      <div class="row crud-container">
        <div
          class="row crud-container mt-1"
          *ngIf="campaignDetail.Status !== 'Pending' && campaignDetail.Status === 'Cancelled'"
        >
          <div class="col-1">
            <label class="form-check-label checkbox-inline">Message</label>
          </div>
          <div class="col-2">
            <button class="btn btn-outline-primary preview-btn"><i class="bi"></i> Preview</button>
          </div>
        </div>
        <div
          class="form-group inp-txt"
          *ngIf="campaignDetail.Status === 'Pending' && campaignDetail.Status !== 'Cancelled'"
        >
          <label class="search-label" for="messageSource">Message Source</label>
          <select
            id="messageSource"
            class="inp"
            *ngIf="campaignDetail && channels.length > 0"
            [(ngModel)]="campaignDetail.Channel"
          >
            <ng-container *ngFor="let item of channels">
              <option [ngValue]="item">{{ item.label }}</option>
            </ng-container>
          </select>
        </div>

        <div
          class="form-group inp-txt"
          *ngIf="campaignDetail.Status === 'Pending' && campaignDetail.Status !== 'Cancelled'"
        >
          <input class="form-control file-upload" type="file" id="formFile" />
        </div>
      </div>

      <div class="row crud-container">
        <div class="form-group inp-txt">
          <label class="search-label" for="playMessage">Play Message</label>
          <select id="playMessage" class="inp" [(ngModel)]="campaignDetail.IVRPrompt.Attributes.loop">
            <option [ngValue]="campaignDetail.IVRPrompt.Attributes.loop">
              {{ campaignDetail.IVRPrompt.Attributes.loop }}
            </option>
          </select>
        </div>

        <div class="form-group inp-txt">
          <label class="search-label" for="actionKey">Action Key</label>
          <select id="actionKey" class="inp" [(ngModel)]="campaignDetail.IVRPrompt.Attributes.actionKey">
            <option [ngValue]="campaignDetail.IVRPrompt.Attributes.actionKey">
              {{ campaignDetail.IVRPrompt.Attributes.actionKey }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!------------ Section 4 ---------->
    <div class="details" style="margin-bottom: 5rem">
      <div class="heading">
        <span class="sub-heading">CONTACT DATA</span>
        <hr class="solid-divider" />
      </div>

      <div class="row crud-container">
        <div class="form-group inp-txt">
          <label for="dataFileProcess">Data File Process</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control inp"
            id="dataFileProcess"
            placeholder="Last Updated On"
            [value]="campaignDetail?.Description"
          />
        </div>
      </div>

      <div class="row crud-container">
        <div class="form-group inp-txt inp-ta" style="width: 70rem">
          <label for="processResult">Process Result</label>
          <textarea
            style="padding-left: 0"
            [readonly]="true"
            class="form-control"
            id="processResult"
            placeholder="Last Updated On"
            [value]="campaignDetail?.Description"
          ></textarea>
        </div>
      </div>

      <div class="row crud-container">
        <div class="form-group mt-1 data-file-container">
          <div class="data-file-div"><strong>Data File</strong> (File, Max. 1)</div>

          <div class="data-file-div" style="height: 4.1rem">
            <div class="data-file-doc">
              <i class="bi bi-folder"></i> NewTextDocument.txt
              <div class="data-file-size">Size 2MB</div>
            </div>
          </div>
          <div class="row crud-container">
            <input
              class="btn btn-outline-primary update-btn"
              type="submit"
              value="Update"
              (click)="saveChanges()"
              style="float: left"
            />
          </div>
        </div>
      </div>
      <div
        class="row crud-container data-file-div"
        *ngIf="campaignDetail.Status !== 'Pending' && campaignDetail.Status === 'Cancelled'"
      >
        <div class="col-3">
          <label class="file-format-template">File Description</label>
        </div>
        <div class="col-3">
          <label class="show-template">Show/Hide</label>
        </div>
        <div class="col-3">
          <button class="btn btn-outline-primary download-btn" (click)="saveChanges()">Download</button>
        </div>
      </div>
      <div
        class="row crud-container"
        *ngIf="campaignDetail.Status !== 'Pending' && campaignDetail.Status === 'Cancelled'"
      >
        <table class="table">
          <tbody>
            <tr>
              <td>ID</td>
              <td></td>
            </tr>
            <tr>
              <td>Name</td>
              <td></td>
            </tr>
            <tr>
              <td>Description</td>
              <td></td>
            </tr>
            <tr>
              <td>Size</td>
              <td></td>
            </tr>
            <tr>
              <td>URL</td>
              <td></td>
            </tr>
            <tr>
              <td>Disabled</td>
              <td></td>
            </tr>
            <tr>
              <td>Created</td>
              <td></td>
            </tr>
            <tr>
              <td>Last Updated</td>
              <td></td>
            </tr>
            <tr>
              <td>File Type</td>
              <td></td>
            </tr>
            <tr>
              <td>Creator</td>
              <td></td>
            </tr>
            <tr>
              <td>Updater</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row crud-container">
        <div class="form-group inp-txt">
          <label for="dataFileProcess">Records Loaded</label>
          <input
            type="text"
            [readonly]="true"
            class="form-control inp"
            id="dataFileProcess"
            placeholder="Last Updated On"
            [value]="campaignDetail?.TotalRecords"
          />
        </div>
      </div>

      <div class="row crud-container">
        <div class="col-2 no-padding">
          <label class="format-template">Format Template</label>
        </div>
        <div class="col-2 mt-1">
          <button class="btn btn-outline-primary update-btn" (click)="saveChanges()">
            <i class="bi bi-download"></i> Download Simple csv file
          </button>
        </div>
      </div>
    </div>

    <!------------ Section 5 ---------->
    <div
      class="details"
      style="margin-bottom: 5rem"
      *ngIf="
        campaignDetail.Status !== 'Pending' &&
        (campaignDetail.Status === 'Cancelled' || campaignDetail.Status === 'Complete')
      "
    >
      <div class="heading">
        <span class="sub-heading">CAMPAIGN RESULTS</span>
        <hr class="solid-divider" />
      </div>

      <div class="row crud-container mt-1">
        <div class="col-2">
          <label class="form-check-label checkbox-inline"
            >Message
            <div class="campaign-progress">
              <span class="scale-left">0</span>
              <span class="scale-right">100</span>
            </div>
          </label>
        </div>
        <div class="col form-group"></div>
      </div>

      <div class="row crud-container">
        <div class="form-group inp-txt">
          <label for="started">Started</label>
          <input
            type="text"
            class="form-control inp"
            id="started"
            placeholder="Started"
            [value]="campaignDetail?.Start | custdate"
          />
        </div>

        <div class="form-group inp-txt">
          <label for="completed">Completed</label>
          <input
            type="text"
            class="form-control inp"
            id="completed"
            placeholder="Completed"
            [value]="campaignDetail?.End | custdate"
          />
        </div>

        <div class="form-group inp-txt">
          <label for="runningTime">Running Time</label>
          <input
            type="text"
            class="form-control inp"
            id="runningTime"
            placeholder="Running Time"
            [value]="campaignDetail?.RunningTime"
          />
        </div>

        <div class="form-group inp-txt">
          <label for="callsMade">Calls Made</label>
          <input
            type="text"
            class="form-control inp"
            id="callsMade"
            placeholder="Calls Made"
            [value]="campaignDetail?.CallsMade"
          />
        </div>
      </div>

      <div class="row crud-container">
        <div class="form-group inp-txt">
          <label for="failures">Failures</label>
          <input
            type="text"
            class="form-control inp"
            id="failures"
            placeholder="Failures"
            [value]="campaignDetail?.Failures"
          />
        </div>

        <div class="form-group inp-txt">
          <label for="successes">Successes</label>
          <input
            type="text"
            class="form-control inp"
            id="successes"
            placeholder="Successes"
            [value]="campaignDetail?.Successes"
          />
        </div>

        <div class="form-group inp-txt">
          <label for="responses">Responses</label>
          <input
            type="text"
            class="form-control inp"
            id="responses"
            placeholder="Responses"
            [value]="campaignDetail?.Responses"
          />
        </div>
      </div>

      <div class="row crud-container">
        <div class="form-group no-padding">
          <input
            class="btn btn-outline-primary update-btn"
            type="submit"
            value="View Details"
            (click)="saveChanges()"
            style="float: left"
          />
          <button class="btn btn-outline-primary update-btn" (click)="saveChanges()" style="float: left">
            <i class="bi bi-repeat"></i> Refresh
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
